import { render, staticRenderFns } from "./CoLibLogin.vue?vue&type=template&id=fd60919c&scoped=true"
import script from "./CoLibLogin.vue?vue&type=script&lang=js"
export * from "./CoLibLogin.vue?vue&type=script&lang=js"
import style0 from "./CoLibLogin.vue?vue&type=style&index=0&id=fd60919c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd60919c",
  null
  
)

export default component.exports